var map = {
	"./75+YearsOfExperience.png": [
		8817,
		8817
	],
	"./75+YearsOfExperience1.png": [
		4332,
		4332
	],
	"./AbilityToAdviceOfCrossBorderTransactions.png": [
		6546,
		6546
	],
	"./About-Us.jpg": [
		2037,
		2037
	],
	"./AccountingAndBookkeeping.png": [
		1743,
		1743
	],
	"./AccountingAndBookkeeping1.png": [
		566,
		566
	],
	"./AccountingAndBookkeeping1C.png": [
		7679,
		7679
	],
	"./AccountingAndBookkeeping2.png": [
		5453,
		5453
	],
	"./AdvisoryServices.png": [
		1892,
		1892
	],
	"./AmatyaConsultantsLogo.jpeg": [
		4368,
		4368
	],
	"./BusinessRegistration.png": [
		4624,
		4624
	],
	"./BusinessRegistration1.png": [
		4635,
		4635
	],
	"./CompanySecretarialServices.png": [
		8719,
		8719
	],
	"./CompanySecretarialServices1.png": [
		4950,
		4950
	],
	"./EstatePlanning.png": [
		822,
		822
	],
	"./FasterTurnaroundTime.png": [
		3935,
		3935
	],
	"./GST.png": [
		6619,
		6619
	],
	"./IntegratedServicesToProvidedRoundedAdvisory.png": [
		9864,
		9864
	],
	"./InternationalTaxation.png": [
		4703,
		4703
	],
	"./Logo.png": [
		5636
	],
	"./MergerAndAcquisition.png": [
		6635,
		6635
	],
	"./Mission.png": [
		7527,
		7527
	],
	"./OnlineAccounting.png": [
		3459,
		3459
	],
	"./OnlineAccounting1.png": [
		9970,
		9970
	],
	"./PayrollManagement.png": [
		9823,
		9823
	],
	"./PayrollManagement1.png": [
		4822,
		4822
	],
	"./PermitsAndLicense.png": [
		7177,
		7177
	],
	"./ProficientInEnglishLanguage.png": [
		5035,
		5035
	],
	"./QualifiedTeam.png": [
		8424,
		8424
	],
	"./QualifiedTeamOfAccountants,Lawyers,Company1.png": [
		5237,
		5237
	],
	"./SaleOfPropertyInIndia.png": [
		1872,
		1872
	],
	"./ServiceBackground.jpg": [
		1556,
		1556
	],
	"./SinglePointContact.png": [
		4795,
		4795
	],
	"./SinglePointContact1.png": [
		3946,
		3946
	],
	"./SolutionOrientedApproach.png": [
		2300,
		2300
	],
	"./TailoredServicesToMeetTheClientRequirement.png": [
		3996,
		3996
	],
	"./TaxCompliances.png": [
		872,
		872
	],
	"./TaxLitigation.png": [
		5192,
		5192
	],
	"./TaxLitigation1.png": [
		1251,
		1251
	],
	"./Valuation.png": [
		448,
		448
	],
	"./Vision.png": [
		9157,
		9157
	],
	"./arrowhead-up.png": [
		6068,
		6068
	],
	"./email.png": [
		5545
	],
	"./email1.png": [
		7972
	],
	"./email2.png": [
		6879,
		6879
	],
	"./facebook.png": [
		6321
	],
	"./google-maps.png": [
		8274,
		8274
	],
	"./linkedin.png": [
		3331
	],
	"./location.png": [
		8680
	],
	"./logo-100.png": [
		7058,
		7058
	],
	"./logo-16.png": [
		5766,
		5766
	],
	"./logo-32.png": [
		1944,
		1944
	],
	"./logo-50.png": [
		4236,
		4236
	],
	"./n1.jpeg": [
		583,
		583
	],
	"./phone.png": [
		333
	],
	"./twitter.png": [
		980,
		980
	],
	"./twitter1.png": [
		2455,
		2455
	],
	"./twitter2.png": [
		1820
	],
	"./whatsapp.png": [
		2291
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8431;
module.exports = webpackAsyncContext;